import type { ErasureCreateInput, LegalHoldCreateInput, SarCreateInput } from '@today/models'
import {
	type ComplianceDownloadLink,
	type CompliancePage,
	ComplianceRoutes,
	type ErasureRequestDTO,
	type LegalHoldDTO,
	type SarFormat,
	type SubjectAccessRequestDTO,
} from '@today/types'
import { apiClient } from './api.client'

/**
 * compliance-service API client (TO-232 compliance-admin-ui). Shapes are the
 * `@today/types` compliance DTOs; the routes come from `ComplianceRoutes`.
 */

const withId = (route: string, id: string) => route.replace('{id}', encodeURIComponent(id))

export const complianceService = {
	listErasures: async (params: Record<string, string>) =>
		(await apiClient.get<CompliancePage<ErasureRequestDTO>>(ComplianceRoutes.listErasures, { params })).data,
	getErasure: async (id: string) =>
		(await apiClient.get<ErasureRequestDTO>(withId(ComplianceRoutes.getErasure, id))).data,
	createErasure: async (body: ErasureCreateInput) =>
		(await apiClient.post<ErasureRequestDTO>(ComplianceRoutes.createErasure, body)).data,
	confirmErasure: async (id: string) =>
		(await apiClient.post<ErasureRequestDTO>(withId(ComplianceRoutes.confirmErasure, id))).data,
	cancelErasure: async (id: string) =>
		(await apiClient.post<ErasureRequestDTO>(withId(ComplianceRoutes.cancelErasure, id))).data,
	certificateLink: async (id: string) =>
		(await apiClient.post<ComplianceDownloadLink>(withId(ComplianceRoutes.erasureCertificateLink, id))).data,
	listLegalHolds: async (params: Record<string, string>) =>
		(await apiClient.get<CompliancePage<LegalHoldDTO>>(ComplianceRoutes.listLegalHolds, { params })).data,
	placeLegalHold: async (body: LegalHoldCreateInput) =>
		(await apiClient.post<LegalHoldDTO>(ComplianceRoutes.placeLegalHold, body)).data,
	releaseLegalHold: async (id: string) =>
		(await apiClient.post<LegalHoldDTO>(withId(ComplianceRoutes.releaseLegalHold, id))).data,
	listSars: async (params: Record<string, string>) =>
		(await apiClient.get<CompliancePage<SubjectAccessRequestDTO>>(ComplianceRoutes.listSars, { params })).data,
	createSar: async (body: SarCreateInput) =>
		(await apiClient.post<SubjectAccessRequestDTO>(ComplianceRoutes.createSar, body)).data,
	sarDownloadLink: async (id: string, format: SarFormat) =>
		(await apiClient.post<ComplianceDownloadLink>(withId(ComplianceRoutes.sarDownloadLink, id), { format })).data,
}
